import script from "./EditGroupForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditGroupForm.vue?vue&type=script&setup=true&lang=js"

import "./EditGroupForm.vue?vue&type=style&index=0&id=9980ec14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9980ec14"]])

export default __exports__